export const USER_PREFERENCES = 'userPreferences'
